import { defineStore } from "pinia"
import { getProjectOnboarding } from "@/services/adminBackendClient"

type OnboardingState = {
   dataReceived: boolean | null
   rewardReceived: boolean | null
   tier: string | null
   trial_days: number | null
   id: string | null
   status: string | null
   expires_at: number | null
   customer_email: string | null
}

export const useOnboardingStore = defineStore("onboardingStore", {
   state: (): OnboardingState => {
      return {
         dataReceived: null,
         rewardReceived: null,
         tier: null,
         trial_days: null,
         id: null,
         status: null,
         expires_at: null,
         customer_email: null,
      }
   },
   getters: {
      fullyOnboarded: (state) => {
         if (!state.dataReceived || !state.rewardReceived) {
            return false
         }
         return true
      },
   },
   actions: {
      async fetchProjectOnboarding() {
         const response = await getProjectOnboarding()
         this.dataReceived = response.data.project_flags.data_received
         this.rewardReceived = response.data.project_flags.reward_received
      },
      clearState() {
         this.dataReceived = null
         this.rewardReceived = null
         this.tier = null
         this.trial_days = null
         this.id = null
         this.status = null
         this.expires_at = null
         this.customer_email = null
      },
      setTier(tier: string | null) {
         this.tier = tier
      },
      setCheckoutSession(sessionData: {
         tier: string
         trial_days: number
         id: string
         status: string
         expires_at: number
         customer_email: string
      }) {
         this.tier = sessionData.tier
         this.trial_days = sessionData.trial_days
         this.id = sessionData.id
         this.status = sessionData.status
         this.expires_at = sessionData.expires_at
         this.customer_email = sessionData.customer_email
      },
   },
   persist: true,
})
